import type { TranslateFn } from './LanguageContext';
import type { TranslationKey } from './dictionaries/en';

/** Office role enum -> display label. The six OFFICE_ROLES values (@wms/foundation/authz). */
const ROLE_KEYS: Record<string, TranslationKey> = {
  ADMIN: 'role.ADMIN',
  WAREHOUSE: 'role.WAREHOUSE',
  PICKER: 'role.PICKER',
  PACKER: 'role.PACKER',
  BILLING: 'role.BILLING',
  SUPPORT: 'role.SUPPORT',
};

export function roleLabel(t: TranslateFn, role: string): string {
  const key = ROLE_KEYS[role];
  return key ? t(key) : role;
}
